import { BackupRequestDTO, BackupRequestLookupsDTO } from "@/core/dto/deduction/remittance";
import { GET_BACKUP_REQUEST_CONFIG, RAISE_BACKUP_REQUEST } from "@/core/graphql/remittance";
import {
  IBackupRequestRepository,
  IBackupRequestRepositoryResponse,
  IBackupRequestTypeResponse,
} from "@/core/repositories/remittance/backupRequest/IBackupRequest.repository";
import { ApolloClient } from "@apollo/client";

export class BackupRequestRepository implements IBackupRequestRepository {
  constructor(private readonly client: ApolloClient) {}

  async backupRequest(params: BackupRequestDTO): Promise<IBackupRequestRepositoryResponse> {
    const { data, error } = await this.client.mutate<IBackupRequestRepositoryResponse>({
      mutation: RAISE_BACKUP_REQUEST,
      variables: { params },
    });

    if (!data?.backupRequest) {
      throw new Error(error?.message || "Failed to request backup document");
    }

    return data;
  }

  async getBackupRequestLookups(params: BackupRequestLookupsDTO): Promise<IBackupRequestTypeResponse> {
    const { data, error } = await this.client.query<IBackupRequestTypeResponse>({
      query: GET_BACKUP_REQUEST_CONFIG,
      variables: { params },
    });

    if (!data?.backupRequestConfig) {
      throw new Error(error?.message || "Failed to fetch request backup lookups");
    }

    return data;
  }
}
